module.exports = __webpack_public_path__ + "static/media/regua-realizacao.0264b0b2.png";